module.exports = __webpack_public_path__ + "images/liveTouchNotif-740d8adf19167091d919815b8997ceee.png";